<template>
  <div class="loading" v-if="loading">
    <loading />
  </div>
  <bar-stack-chart
    v-else
    height="300px"
    :prop-map="propMap"
    :view-model="data"
    :two-yaxis="true"
    :cust-yaxis="yAxis"
    :tooltip-formater="tooltipRender"
    :data-zoom="30"
    tooltip-class="cust-line-chart-tooltip"
  />
</template>
<script>
import { QueryTopCustomer } from '../services'
import BarStackChart from '@/components/BarStackChart.vue'
import Loading from '@/components/Loading.vue'
import _ from 'lodash'
import moment from 'moment'
export default {
  name: 'CustomerBarStackChart',
  props: {
    timeSpan: {
      type: Array,
      default () {
        return null
      }
    }
  },
  components: { BarStackChart, Loading },
  data () {
    return {
      loading: true,
      data: [],
      propMap: {
        xAxis: 'name',
        service: '消费>>服务消费',
        partOrder: '消费>>配件消费',
        orderCount: '下单次数',
        spliter: '>>'
      },
      yAxis: [
        {
          name: '金额',
          type: 'value',
          stack: ['消费']
        },
        {
          name: '次数',
          type: 'value',
          min: 1,
          stack: ['下单次数']
        }
      ]
    }
  },
  computed: {
    startDay () {
      if (this.timeSpan) {
        return moment(this.timeSpan[0]).format('YYYY-MM-DD')
      }
      return undefined
    },
    endDay () {
      if (this.timeSpan) {
        return moment(this.timeSpan[1]).format('YYYY-MM-DD')
      }
      return undefined
    }
  },
  watch: {
    startDay () {
      this.loadDataDebounce()
    },
    endDay () {
      this.loadDataDebounce()
    },
    newAdd () {
      this.loadDataDebounce()
    },
    area () {
      this.loadDataDebounce()
    }
  },
  created () {
    this.loadDataDebounce = _.debounce(() => {
      this.loadData()
    }, 30)
  },
  mounted () {
    this.loadDataDebounce()
  },
  methods: {
    loadData () {
      this.loading = true
      QueryTopCustomer({ startDay: this.startDay, endDay: this.endDay, newAdd: this.newAdd, area: this.area || undefined }).then(resp => {
        this.data = resp
      }).finally(() => {
        this.loading = false
      })
    },
    tooltipRender (params, ticket) {
      const rowItems = params.map(element => {
        return `
        <div class="serie-item">
          <div style="--serie-color:${element.color}">
            <div class="serie-color-block"></div>
          </div>
          <div>${element.seriesName}</div>
          <div>${element.data}</div>
        </div>
        `
      })
      return `
<div>
  <div class="date" style="word-break: break-all;">${params[0].axisValue}</div>
  ${rowItems.join('')}
</div>
      `
    }
  }
}
</script>
